var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.modules,
          columns: _vm.columns_modules,
          "row-key": "id",
          pagination: _vm.pagination_modules,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination_modules = $event
          },
          request: _vm.requestModules
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "title", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.title) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "module_score", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.module_score) +
                            "\n                "
                        )
                      ]
                    ),
                    _c("q-td", { key: "qty_views", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.qty_views) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatus(props.row.status),
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getTextStatusModule(props.row.status)
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "actions",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "secondary",
                              icon: "far fa-users"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showModuleUsers(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("participants_report_tooltip")
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_module_users,
            callback: function($$v) {
              _vm.show_module_users = $$v
            },
            expression: "show_module_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_module_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.module.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    ref: "table",
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.users,
                      columns: _vm.columns_users,
                      "row-key": "user_id",
                      pagination: _vm.pagination_users,
                      loading: _vm.loading,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      filter: _vm.filter_users,
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination_users = $event
                      },
                      request: _vm.requestUserModules
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter_users,
                                callback: function($$v) {
                                  _vm.filter_users = $$v
                                },
                                expression: "filter_users"
                              }
                            }),
                            _c("div", { staticClass: "col" })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return [
                            _c(
                              "q-tr",
                              { attrs: { props: props } },
                              [
                                _c(
                                  "q-td",
                                  { key: "full_name", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(props.row.full_name) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "email", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(props.row.email) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "watch_date",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.fDate(props.row.watch_date)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "module_score",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(props.row.module_score) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "status",
                                    attrs: { props: props, "auto-width": "" }
                                  },
                                  [
                                    _c(
                                      "q-chip",
                                      {
                                        staticClass: "full-width text-center",
                                        attrs: {
                                          small: "",
                                          icon: _vm.getIconStatus(
                                            props.row.status
                                          ),
                                          color: _vm.getColorStatus(
                                            props.row.status
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                _vm.getTextStatus(
                                                  props.row.status
                                                )
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }